import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getHistory } from 'store/history/actions';
import { getHistory as getHistorySelector } from 'store/history/selectors';

// temporary component for auth purposes
const History = () => {
  const dispatch = useDispatch();
  const data = useSelector(getHistorySelector);

  useEffect(() => {
    dispatch(getHistory());
  }, []);

  return (
    <table width="100%" style={{ borderSpacing: '15px' }}>
      <thead>
        <tr>
          <th align="center">ID</th>
          <th align="center">User ID</th>
          <th align="center">Data Version</th>
          <th align="center">Type</th>
          <th align="center">Type ID</th>
          <th align="center">Code</th>
          <th align="center">Action</th>
          <th align="center">Created at</th>
          <th align="center">Updated at</th>
        </tr>
      </thead>
      <tbody>
        {
          data.map(({
            id,
            user_id,
            data_version,
            type,
            type_id,
            code,
            action,
            created_at,
            updated_at,
          }) => (
            <tr key={id}>
              <td align="center">{id}</td>
              <td align="center">{user_id}</td>
              <td align="center">{data_version}</td>
              <td align="center">{type}</td>
              <td align="center">{type_id}</td>
              <td align="center">{code}</td>
              <td align="center">{action}</td>
              <td align="center">{created_at}</td>
              <td align="center">{updated_at}</td>
            </tr>
          ))
        }
      </tbody>
    </table>
  );
};

export default History;
